import { FormattedMessage } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";

const AtlassianIntelligence = () => {
    const localizedHref = useLocalizedHref(
        "/software/jira/service-management/product-guide/tips-and-tricks/artificial-intelligence#overview"
    );
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraServiceManagementPricingPageTeam24.features.atlassianIntelligence.content.body"
                    defaultMessage="Atlassian Intelligence improves service experiences for agents and customers and accelerates operations workflows with AI-powered incident and change management. <a>Learn more.</a>"
                    values={{
                        a: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="jira-service-management"
                                data-label-english="learn more"
                                href={localizedHref}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};
export default AtlassianIntelligence;
